import { CONTENT_WIDTH } from "@/enums";
import { Button, Col } from "antd";
import { bool, func, string } from "prop-types";
import { useIntl } from "react-intl";

const EditBaselineDateActions = ({
  pageName,
  loading,
  saveOnClick,
  cancelOnClick,
  saveDisabled,
  deleteOnClick,
  showDelete,
}) => {
  const intl = useIntl();

  return (
    <>
      <Col
        xxl={CONTENT_WIDTH.oneSixth}
        lg={CONTENT_WIDTH.oneQuarter}
        sm={CONTENT_WIDTH.half}
        xs={CONTENT_WIDTH.max}
      >
        <Button
          data-test-id={`${pageName}-cancel`}
          onClick={cancelOnClick}
          block
          disabled={loading}
        >
          {intl.formatMessage({ id: "general.cancel" })}
        </Button>
      </Col>
      {showDelete && (
        <Col
          xxl={CONTENT_WIDTH.oneSixth}
          lg={CONTENT_WIDTH.oneQuarter}
          sm={CONTENT_WIDTH.half}
          xs={CONTENT_WIDTH.max}
        >
          <Button
            data-test-id={`${pageName}-delete`}
            onClick={deleteOnClick}
            block
            loading={loading}
            disabled={saveDisabled}
          >
            {intl.formatMessage({ id: "general.delete" })}
          </Button>
        </Col>
      )}
      <Col
        xxl={CONTENT_WIDTH.oneSixth}
        lg={CONTENT_WIDTH.oneQuarter}
        sm={CONTENT_WIDTH.half}
        xs={CONTENT_WIDTH.max}
      >
        <Button
          data-test-id={`${pageName}-save`}
          type="primary"
          onClick={saveOnClick}
          block
          loading={loading}
          disabled={saveDisabled}
          htmlType="submit"
        >
          {intl.formatMessage({ id: "general.save" })}
        </Button>
      </Col>
    </>
  );
};

EditBaselineDateActions.propTypes = {
  saveOnClick: func.isRequired,
  cancelOnClick: func.isRequired,
  deleteOnClick: func.isRequired,
  pageName: string.isRequired,
  loading: bool,
  saveDisabled: bool,
  showDelete: bool,
};

export default EditBaselineDateActions;
